import React, { useEffect, useState, useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { getUserError, getUserStatus } from '../store/slices/userSlice';
import $ from "jquery"
import 'datatables.net'
import Modal from 'react-modal';
import { addFished, deleteFished, editFishEd, getFished } from '../store/featureActions';
import { DateRangePicker } from "react-date-range";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import moment from "moment";
import ImageViewer from "react-simple-image-viewer";

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        width: "30%",
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        border: "0px",
        padding: "0px",
    },
};
Modal.setAppElement('#root');
const FishEdList = () => {
    const [id, setId] = useState()
    const dispatch = useDispatch()
    const status = useSelector(getUserStatus)
    const error = useSelector(getUserError)
    const [fishedList, setFishedList] = useState(null)
    const [detail, setDetail] = useState(null)
    const [modalIsOpen, setIsOpen] = useState(false);
    const [modalType, setModalType] = useState()
    const [title, setTitle] = useState()
    const [videoLink, setVideoLink] = useState()
    const [articleLink, setArticleLink] = useState()
    const [articleImage, setArticleImage] = useState()
    const [file, setFile] = useState()
    const [videoThumbnail, setVideoThumbnail] = useState()
    const [deleteFile, setDeleteFile] = useState(0)
    const [source, setSource] = useState()
    const [author, setAuthor] = useState()
    const [description, setDescription] = useState()
    const [startDate, setStartDate] = useState();
    const [endDate, setEndDate] = useState();
    const [modalImages, setmodalImages] = useState(false);
    const [currentImage, setCurrentImage] = useState(0);
    const [range, setRange] = useState({
        startDate: new Date(),
        endDate: new Date(),
        key: "selection",
    });

    const today = new Date();
    const minSelectableDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
    const openImageViewer = useCallback((images, index) => {
        setCurrentImage(index);
        setmodalImages(images);
    }, []);
    const handleSelect = (ranges) => {
        setRange(ranges.selection);
        // console.log(ranges.selection)
        setStartDate(moment(ranges?.selection?.startDate).format("YYYY-MM-DD"));
        setEndDate(moment(ranges?.selection?.endDate).format("YYYY-MM-DD"));
    };
    function viewModal(item, type) {
        if (type == "detail") {
            setDetail(item)
        } else if (type == "create") {
            setId(item)
        } else if (type == "edit") {
            setDetail(item)
            setVideoLink(item?.videoLink || "")
            setArticleLink(item?.articleLink || "")
            setTitle(item?.title || "")
            setSource(item?.source || "")
            setAuthor(item?.author || "")
            setDescription(item?.description || "")
            setRange({
                startDate: item?.startDate,
                endDate: item?.endDate,
                key: "selection",
            })
            setId(item?._id)
        } else if (type == "delete") {
            setId(item)
        }
        setModalType(type)
        setIsOpen(true);
    }
    function closeModal() {
        setIsOpen(false);
        setTitle()
        setDescription()
        setVideoLink()
        setAuthor()
        setSource()
        setDeleteFile(0)
        setArticleLink()
        setFile()
        setVideoThumbnail()
        setEndDate()
        setStartDate()
        setRange({
            startDate: new Date(),
            endDate: new Date(),
            key: "selection",
        })
        setCurrentImage(0);
        setmodalImages(false);
    }

    const fishEdDelete = async (id) => {
        try {
            let payload = {
                params: id,
                isToast: true
            }
            await dispatch(deleteFished(payload)).unwrap()
            setIsOpen(false)
            $('#tableData')
                .DataTable().destroy();
            try {
                ListFished()
            } catch (rejectedValueOrSerializedError) {
                console.log(rejectedValueOrSerializedError)
            }
        } catch (rejectedValueOrSerializedError) {
            console.log(rejectedValueOrSerializedError)
        }
    }

    const fishEdEdit = async () => {
        try {
            let formData = new FormData()
            const fields = {
                title,
                description,
                author,
                source,
                startDate,
                endDate,
                deleteFile
            };

            for (const [fieldName, fieldValue] of Object.entries(fields)) {
                if (fieldValue) {
                    formData.append(fieldName, fieldValue);
                }
            }
            formData.append("videoLink", videoLink || "");
            formData.append("articleLink", articleLink || "");
            if (deleteFile == 0) {
                formData.append("reelEd", file);
            }
            let payload = {
                body: formData,
                params: id,
                isToast: true
            }
            await dispatch(editFishEd(payload)).unwrap()
            closeModal()
            $('#tableData')
                .DataTable().destroy();
            ListFished()
        } catch (rejectedValueOrSerializedError) {
            console.log(rejectedValueOrSerializedError)
        }
    }

    const FishEd = async () => {
        let formData = new FormData()
        const fields = {
            title,
            description,
            reelEd: file,
            videoLink,
            articleLink,
            author,
            source,
            startDate,
            endDate
        };

        for (const [fieldName, fieldValue] of Object.entries(fields)) {
            if (fieldValue) {
                formData.append(fieldName, fieldValue);
            }
        }
        let payload = {
            body: formData,
            params: false,
            isToast: true
        }
        try {
            await dispatch(addFished(payload)).unwrap()
            setIsOpen(false)
            setTitle()
            setDescription()
            setVideoLink()
            setAuthor()
            setDeleteFile(0)
            setSource()
            setArticleLink()
            setFile()
            setVideoThumbnail()
            setEndDate()
            setStartDate()
            setRange({
                startDate: new Date(),
                endDate: new Date(),
                key: "selection",
            })
            if (fishedList) {
                $('#tableData')
                    .DataTable().destroy();
            }
            ListFished()
        } catch (rejectedValueOrSerializedError) {
            console.log(rejectedValueOrSerializedError)
        }
    }

    const ListFished = async () => {
        try {
            setFishedList(null)
            let payload = {
                params: false,
                isToast: false
            }
            const response = await dispatch(getFished(payload)).unwrap()
            setFishedList(response?.data?.fishedList)
        } catch (rejectedValueOrSerializedError) {
            console.log(rejectedValueOrSerializedError)
        }
    }

    useEffect(() => {
        let mount = true
        if (mount) {
            ListFished();
        }
        return () => {
            mount = false
        }
    }, [])
    useEffect(() => {
        if (fishedList) {
            $('#tableData')
                .DataTable({
                    lengthMenu: [10, 25, 50, 100, 200],
                    language: {
                        "emptyTable": "Reel Ed List Not Found"
                    },
                    destroy: true,
                });
        }
    }, [fishedList])
    return (
        <>
            <Modal
                closeTimeoutMS={500}
                isOpen={modalIsOpen}
                onRequestClose={closeModal}
                style={customStyles}
                contentLabel="Change Password"
            >
                <div className='change-password-modal' id="exampleModalCenter" tabIndex={-1} aria-labelledby="exampleModalCenterTitle" aria-hidden="true" style={{ display: "block", zIndex: 100 }}>
                    {modalType == "detail" ? <>
                        <div className="headerModal">
                            <p className="pass-text">Detail</p>
                            <button onClick={closeModal} type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                        </div>
                        <div className="modal-body">
                            <p > <b>Source:</b> {detail?.source ? detail?.source : <>No Source Found</>} </p>
                            <p > <b>Title:</b> {detail?.title ? detail?.title : <>No Title Found</>} </p>
                            <p > <b>Description:</b> {detail?.description ? detail?.description : <>No Description Found</>} </p>
                            {detail?.videoLink ? <p > <b>Video Link:</b> <a className='text-decoration-underline text-wrap' target='_blank' href={detail?.videoLink}>{detail?.videoLink}</a></p> : <></>}
                            {detail?.videoThumbnail ? <p > <b>Video Thumbnail:</b> <img onClick={() => openImageViewer([detail?.videoThumbnail], 0)} height="20%" width="20%" style={{ borderRadius: 5 }} src={detail?.videoThumbnail}></img></p> : <></>}
                            {detail?.articleLink ? <p > <b>Article Link:</b> <a className='text-decoration-underline text-wrap' target='_blank' href={detail?.articleLink}>{detail?.articleLink}</a></p> : <></>}
                            {detail?.articleImage ? <p onClick={() => openImageViewer([detail?.articleImage], 0)}> <b>Article Image:</b> <img height="20%" width="20%" style={{ borderRadius: 5 }} src={detail?.articleImage}></img></p> : <></>}
                        </div>
                    </> : modalType == "create" ? <>
                        <div className="headerModal">
                            <p className="pass-text">Add Reel Ed</p>
                            <button onClick={closeModal} type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                        </div>
                        <div className="modal-body">
                            <div className="input-group input-group-sm mb-3 w-100">
                                <input type="text" maxLength={50} className="form-control" placeholder='Enter Source' aria-label="Source" value={source} onChange={(e) => setSource(e.target.value)} />
                            </div>
                            <div className="input-group input-group-sm mb-3 w-100">
                                <input type="text" maxLength={50} className="form-control" placeholder='Enter Author' aria-label="Author" value={author} onChange={(e) => setAuthor(e.target.value)} />
                            </div>
                            <div className="input-group input-group-sm mb-3 w-100">
                                <input type="text" maxLength={50} className="form-control" placeholder='Enter Title' aria-label="Title" value={title} onChange={(e) => setTitle(e.target.value)} />
                            </div>
                            <div className="input-group input-group-sm mb-3 w-100">
                                <input type="text" className="form-control" placeholder='Enter Video Link' aria-label="Video Link" value={videoLink} onChange={(e) => setVideoLink(e.target.value)} />
                            </div>
                            <div className="input-group input-group-sm mb-3 w-100">
                                <input type="text" className="form-control" placeholder='Enter Article Link' aria-label="Article Link" value={articleLink} onChange={(e) => setArticleLink(e.target.value)} />
                            </div>
                            <div className="input-group input-group-sm mb-3 w-100">
                                <input type="file" className="form-control" id="inputGroupFile01" onChange={(e) => setFile(e.target.files[0])} />
                            </div>
                            <div className="input-group input-group-sm mb-3 w-100">
                                <textarea maxLength={150} className="form-control text-area-class" placeholder='Enter Description' aria-label="Description" value={description} onChange={(e) => setDescription(e.target.value)} />
                            </div>
                            <button className="excel-btn col-reds w-10 pt-2 pb-2" style={{ backgroundColor: "#0077DC" }} type="submit" onClick={FishEd}>Create</button>
                        </div>
                    </> : modalType == "edit" ? <>
                        <div className="headerModal">
                            <p className="pass-text">Edit Reel Ed</p>
                            <button onClick={closeModal} type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                        </div>
                        <div className="modal-body">
                            <div className="input-group input-group-sm mb-3 w-100">
                                <input type="text" maxLength={50} className="form-control" placeholder='Enter Source' aria-label="Source" defaultValue={detail.source} value={source} onChange={(e) => setSource(e.target.value)} />
                            </div>
                            <div className="input-group input-group-sm mb-3 w-100">
                                <input type="text" maxLength={50} className="form-control" placeholder='Enter Author' aria-label="Author" defaultValue={detail.author} value={author} onChange={(e) => setAuthor(e.target.value)} />
                            </div>
                            <div className="input-group input-group-sm mb-3 w-100">
                                <input type="text" maxLength={50} className="form-control" placeholder='Enter Title' aria-label="Title" defaultValue={detail.title} value={title} onChange={(e) => setTitle(e.target.value)} />
                            </div>
                            <div className="input-group input-group-sm mb-3 w-100">
                                <input type="text" className="form-control" placeholder='Enter Video Link' aria-label="Video Link" defaultValue={detail.videoLink} value={videoLink} onChange={(e) => setVideoLink(e.target.value)} />
                            </div>
                            <div className="input-group input-group-sm mb-3 w-100">
                                <input type="text" className="form-control" placeholder='Enter Article Link' aria-label="Article Link" defaultValue={detail.articleLink} value={articleLink} onChange={(e) => setArticleLink(e.target.value)} />
                            </div>
                            <div className="input-group input-group-sm mb-3 w-100">
                                <input type="file" className="form-control" id="inputGroupFile01" onChange={(e) => { setFile(e.target.files[0]); setDeleteFile(0); }} />
                            </div>
                            <div className="input-group input-group-sm mb-3 w-100">
                                {deleteFile == 0 && (file || detail?.videoThumbnail || detail?.articleImage) ?
                                    <div>
                                        <img className='file-class' src={file ? URL.createObjectURL(file) : (detail.videoThumbnail || detail.articleImage)} />
                                        <i onClick={() => setDeleteFile(1)} className="fas fa-trash text-danger trash-class"></i>
                                    </div> : <></>}
                            </div>
                            <div className="input-group input-group-sm mb-3 w-100">
                                <textarea maxLength={150} className="form-control text-area-class" placeholder='Enter Description' aria-label="Description" value={description} defaultValue={detail.description} onChange={(e) => setDescription(e.target.value)} />
                            </div>
                            <button className="excel-btn col-reds w-10 pt-2 pb-2" style={{ backgroundColor: "#0077DC" }} type="submit" onClick={fishEdEdit}>Update</button>
                        </div>
                    </> : modalType == "delete" ? <>
                        <div className="headerModal">
                            <p className="pass-text">Delete Reel Ed Confirmation</p>
                            <button onClick={closeModal} type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                        </div>
                        <div className="modal-body">
                            <form >
                                <div className="pass-form-wrap" style={{ display: "flex", flexDirection: "row", justifyContent: "space-evenly" }}>
                                    <div className="login-button mt-2" style={{ width: "40%" }}>
                                        <button type="button" onClick={() => fishEdDelete(id)} style={{ backgroundColor: "rgba(0, 69, 139,0.8)" }} className="cta-btn col-reds w-100">Delete</button>
                                    </div>
                                    <div className="login-button mt-2" style={{ width: "40%" }} >
                                        <button type="button" onClick={closeModal} style={{ backgroundColor: "rgba(0, 69, 139,0.8)" }} className="cta-btn col-reds w-100">Cancel</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </> : <></>}
                </div>
            </Modal>
            <div style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                marginTop: fishedList ? "3%" : "12%"
            }}>
                <section className="coupon-sec-2">
                    <div className="container tableContainer">
                        <div className=" mt-2 mb-3 d-flex justify-content-end">
                            <button className="excel-btn col-reds w-10 pt-2 pb-2" style={{ backgroundColor: "#0077DC" }} onClick={() => viewModal(null, "create")} >Add Reed Ed
                            </button>
                        </div>
                    </div>
                </section>
                <section className="coupon-sec-2">
                    <div className="container tableContainer">
                        <div className="row">
                            <div className="col-12 col-md-12 col-lg-12">
                                <div className="card shadow mb-4">
                                    <div className="card-body">
                                        <div className="table-responsive" id="tableready">
                                            <table id="tableData" className="table table-bordered display" style={{ width: '100%', textAlign: "center" }}>
                                                <thead>
                                                    {fishedList ? (<tr>
                                                        <th>S.No</th>
                                                        <th>Source</th>
                                                        <th>Title</th>
                                                        <th>Author</th>
                                                        <th>Views</th>
                                                        {/* <th>Status</th> */}
                                                        <th>Detail</th>
                                                        <th>Action</th>
                                                    </tr>) : (<tr></tr>)}
                                                </thead>
                                                <tbody >
                                                    {fishedList?.map((item, i) => (
                                                        <tr key={i}>
                                                            <td>{i + 1}</td>
                                                            <td>{item?.source}</td>
                                                            <td>{item?.title}</td>
                                                            <td>{item?.author}</td>
                                                            <td>{item?.views}</td>
                                                            {/* <td>{moment(new Date()).format("YYYY-MM-DD") >= moment(item?.startDate).format("YYYY-MM-DD") && moment(item?.endDate).format("YYYY-MM-DD") >= moment(new Date()).format("YYYY-MM-DD") ? "Active" : moment(item?.endDate).format("YYYY-MM-DD") < moment(new Date()).format("YYYY-MM-DD") ? "Past" : "Upcoming"}</td> */}
                                                            <td>
                                                                <span className="edit-icon" >
                                                                    <span style={{ cursor: "pointer", fontWeight: "bold", margin: 10, fontSize: 13, }} onClick={() => viewModal(item, "detail")}  ><i className="fas fa-eye"></i> View</span>
                                                                </span>
                                                            </td>
                                                            <td>
                                                                <span className="edit-icon" >
                                                                    <span style={{ cursor: "pointer", fontWeight: "bold", margin: 10 }} onClick={() => viewModal(item, "edit")}  ><i className="fa fa-solid fa-edit"></i> Edit</span>
                                                                    <span style={{ cursor: "pointer", fontWeight: "bold", margin: 10 }} onClick={() => viewModal(item?._id, "delete")}  ><i className="fas fa-trash-alt"></i> Delete</span>
                                                                </span>
                                                            </td>
                                                        </tr>
                                                    )
                                                    )}
                                                </tbody>
                                                {!fishedList ?
                                                    status == "loading" || error ? <tfoot>
                                                        <tr><th>{status == "loading" ? "Loading..." : error ? error : ""}</th></tr>
                                                    </tfoot> : <></> : <></>}
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                {modalImages && (
                    <ImageViewer
                        src={modalImages}
                        currentIndex={currentImage}
                        onClose={closeModal}
                        disableScroll={true}
                        backgroundStyle={{
                            backgroundColor: "rgba(0,0,0,0.9)",
                            zIndex: 3
                        }}
                        closeOnClickOutside={true}
                        showPrevButton={currentImage > 0}
                    />
                )}
            </div >
        </>
    )
}
export default FishEdList
